module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-369.7665f3c.woff2";